module.exports = __webpack_public_path__ + "static/media/respirator.597858de.png";